import { render } from "./NumberControlRenderer.vue?vue&type=template&id=e56b487a&ts=true"
import script from "./NumberControlRenderer.vue?vue&type=script&lang=ts"
export * from "./NumberControlRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__